import { VueReCaptcha } from 'vue-recaptcha-v3';
export default (function (_ref) {
  var Vue = _ref.Vue;
  Vue.use(VueReCaptcha, {
    siteKey: '6LfNsJsUAAAAAL1UShKSxBFPDE02wwEqPKBtHqli',
    loaderOptions: {
      autoHideBadge: true
    }
  });
});